import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _pages;
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Routes } from "../CEF/Common/Constants";
export var pages = (_pages = {}, _defineProperty(_pages, Routes.Preferences.CountriesPage, {
  nextPage: Routes.Preferences.EducationLevelFamiliesPage,
  title: 'Destination Country',
  questionNumber: 'Q1'
}), _defineProperty(_pages, Routes.Preferences.EducationLevelFamiliesPage, {
  nextPage: Routes.Preferences.FieldsOfEducationPage,
  title: 'Level of Education',
  questionNumber: 'Q2'
}), _defineProperty(_pages, Routes.Preferences.FieldsOfEducationPage, {
  nextPage: Routes.Preferences.BudgetPage,
  title: 'Field of Study',
  questionNumber: 'Q3'
}), _defineProperty(_pages, Routes.Preferences.BudgetPage, {
  nextPage: Routes.Preferences.IntakesPage,
  title: 'Budget',
  questionNumber: 'Q4'
}), _defineProperty(_pages, Routes.Preferences.IntakesPage, {
  nextPage: Routes.Eligibility.NationalityQuestion,
  title: 'Intake',
  questionNumber: 'Q5'
}), _defineProperty(_pages, Routes.ApplyBoost.PathwayPage, {
  title: 'Applyboost',
  questionNumber: ''
}), _defineProperty(_pages, Routes.ApplyBoost.AdvisorConfirmationPage, {
  questionNumber: ''
}), _pages);
export var studentOnboarding = 'Student Onboarding';